import React, { useState, useEffect } from 'react';
import { MapPin, Phone, Mail, Users, Stethoscope, Activity, ShieldCheck, Smile, BookOpen, CalendarDays, MessageSquare, Clock3, Baby, Syringe, HeartHandshake, Lightbulb, Sparkles, ChevronDown, ChevronUp, Menu, X, Facebook, Instagram, Youtube, Star, PlusCircle, Circle, ArrowRight, ChevronRight, Linkedin, Search, BriefcaseMedical, User2, Building, Target, Eye, Award, Handshake, Brain, Send, Tag, UserCircle, CalendarRange, Home, AlertTriangle, FileText, UsersRound, CheckCircle, Navigation } from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';
import CapyCorner from './components/CapyCorner/CapyCorner';

// --- DATOS ---
const NEW_PHONE_NUMBER = "51991992717";
const NEW_PHONE_NUMBER_DISPLAY = "+51 991 992 717";

const NAV_LINKS = [
  { name: 'Inicio', href: 'Inicio' },
  { name: 'Quiénes Somos', href: 'Quiénes Somos' },
  { name: 'Servicios', href: 'Servicios' },
  { name: 'Nuestro Equipo', href: 'Nuestro Equipo' },
  { name: 'El Rincón de Capy', href: 'El Rincón de Capy' },
  { name: 'Consejos de Capy', href: 'Consejos de Capy' },
  { name: 'Agendar Cita', href: 'Contacto' },
];

const DOCTORS_DATA_FOR_SELECT = [
  { id: 'any', name: 'Cualquier Pediatra Disponible' },
  { id: '3', name: 'Dra. Diana Andia' },
  { id: '4', name: 'Dra. Betzi Angelino' },
  { id: '5', name: 'Dra. Katherine Paira' },
  { id: '6', name: 'Dr. Daniel Comeca' },
  { id: '2', name: 'Dr. Remy Dorado' },
];

const SERVICES_DATA_FOR_SELECT = [
  { id: 's1', name: 'Control de Niño Sano' },
  { id: 's2', name: 'Vacunación' },
  { id: 's3', name: 'Pediatría General' },
  { id: 's4', name: 'Emergencias Pediátricas' },
  { id: 's5', name: 'Consejería para Adolescentes' },
  { id: 's6', name: 'Nutrición Infantil' },
];

const DOCTORS = [
  {
    name: 'Dra. Diana Andia',
    specialty: 'Médica Pediatra',
    fullBio: 'Con un enfoque en la pediatría preventiva y la nutrición infantil. Promotora de hábitos saludables desde la infancia.',
    areas: ['CMP: 59872', 'RNE: 365050'],
    imgSrc: '/imagenes/doctora-diana-andia.png',
  },
  {
    name: 'Dra. Betzi Angelino',
    specialty: 'Médica Pediatra',
    fullBio: 'Experiencia en atención de urgencias pediátricas y cuidado del adolescente. Fomenta un espacio de confianza para los jóvenes.',
    areas: ['CMP: 62793'],
    imgSrc: '/imagenes/doctora-betzi-angelino.png',
  },
  {
    name: 'Dra. Katherine Paira',
    specialty: 'Médica Pediatra',
    fullBio: 'Dedicada al neurodesarrollo infantil y la detección temprana de trastornos del desarrollo. Trabaja de cerca con las familias.',
    areas: ['CMP: 62796', 'RNE: 38932'],
    imgSrc: '/imagenes/doctora-katherine-paira.png',
  },
  {
    name: 'Dr. Remy Dorado',
    specialty: 'Médico Pediatra',
    fullBio: 'Especialista en enfermedades respiratorias infantiles y alergias. Dedicado a mejorar la calidad de vida de los pequeños con condiciones crónicas.',
    areas: ['CMP: 45840', 'RNE: 24862'],
    imgSrc: '/imagenes/doctor-remy-dorado.png',
  },
  {
    name: 'Dr. Daniel Comeca',
    specialty: 'Médico Pediatra',
    fullBio: 'Especialista en pediatría con amplia trayectoria en el cuidado de la salud infantil y prevención de enfermedades.',
    areas: ['CMP: 75371', 'RNE: 46349'],
    imgSrc: '/imagenes/doctor-daniel-comeca.png',
    imgStyle: { objectFit: 'contain', objectPosition: 'bottom', paddingTop: '1.5rem' },
  },
];

const SERVICES = [
  {
    title: 'Control de Niño Sano',
    description: 'Seguimiento periódico del crecimiento y desarrollo de tu hijo. Evaluación física, nutricional y psicomotora para una detección temprana y oportuna.',
    icon: <Baby className="w-12 h-12 text-[#0073E4]" />,
    capyHelps: '¡Visitar al pediatra regularmente es como darle superpoderes a tu cuerpo para crecer fuerte y sano!',
    serviceImage: '/imagenes/servicio-control-nino-sano.png',
    capyImage: '/imagenes/capy-consejo-nino-sano.png',
  },
  {
    title: 'Vacunación Completa',
    description: 'Protege a tus hijos contra enfermedades prevenibles con nuestro esquema de vacunación actualizado, en un ambiente seguro y tranquilo.',
    icon: <Syringe className="w-12 h-12 text-[#0073E4]" />,
    capyHelps: '¡Las vacunas son escudos mágicos que enseñan a tu cuerpo a defenderse de los bichitos malos!',
    serviceImage: '/imagenes/servicio-vacunacion.png',
    capyImage: '/imagenes/capy-consejo-vacunacion.png',
  },
  {
    title: 'Pediatría General Integral',
    description: 'Atención de enfermedades comunes en la infancia y adolescencia. Diagnóstico y tratamiento oportuno para una pronta recuperación.',
    icon: <Stethoscope className="w-12 h-12 text-[#0073E4]" />,
    capyHelps: 'Si te sientes malito, ¡el doctor pediatra sabe cómo ayudarte a sentirte mejor muy rápido!',
    serviceImage: '/imagenes/servicio-pediatria-general.png',
    capyImage: '/imagenes/capy-consejo-pediatria-general.png',
  },
  {
    title: 'Atención de Emergencias',
    description: 'Cuidado inmediato para condiciones urgentes como fiebre alta, dificultad respiratoria, deshidratación y traumatismos leves.',
    icon: <Activity className="w-12 h-12 text-[#0073E4]" />,
    capyHelps: '¡En una emergencia, mantén la calma! Nuestros doctores están listos para cuidarte.',
    serviceImage: '/imagenes/servicio-emergencias.png',
    capyImage: '/imagenes/capy-consejo-emergencias.png',
  },
  {
    title: 'Consejería para Adolescentes',
    description: 'Espacio de confianza para abordar temas de salud física y emocional: desarrollo, sexualidad, salud mental y prevención de riesgos.',
    icon: <Users className="w-12 h-12 text-[#0073E4]" />,
    capyHelps: '¡Ser adolescente es una gran aventura! Hablar de tus dudas te ayuda a crecer seguro y feliz.',
    serviceImage: '/imagenes/servicio-consejeria-adolescentes.png',
    capyImage: '/imagenes/capy-consejo-adolescentes.png',
  },
  {
    title: 'Nutrición Infantil y Familiar',
    description: 'Asesoramiento nutricional personalizado: lactancia, alimentación complementaria, manejo de sobrepeso, obesidad o bajo peso.',
    icon: <HeartHandshake className="w-12 h-12 text-[#0073E4]" />,
    capyHelps: '¡Comer frutas y verduras te da energía para jugar y aprender todo el día!',
    serviceImage: '/imagenes/servicio-nutricion-infantil.png',
    capyImage: '/imagenes/capy-consejo-nutricion.png',
  },
];

const TESTIMONIALS = [
  {
    quote: 'La Dra. Andia es una profesional increíble, siempre dispuesta a ayudar. Las instalaciones son modernas y acogedoras.',
    name: 'Juan C.',
    city: 'Cusco',
  },
  {
    quote: 'Recomiendo Crecer Pediatría al 100%. El trato es cálido y se nota la vocación de todo el equipo.',
    name: 'Luisa F.',
    city: 'Cusco',
  },
  {
    quote: 'Excelente atención de la Dra. Katherine Paira. Se nota su dedicación y paciencia con los niños. ¡Muy recomendada!',
    name: 'María R.',
    city: 'Cusco',
  },
];

const BLOG_POSTS = [
  {
    id: 1,
    title: 'La importancia de las vacunas: ¡Superpoderes para tu salud!',
    category: 'Vacunación',
    author: 'Capy',
    date: '25 de Mayo, 2025',
    summary: 'Capy te explica de forma divertida por qué las vacunas son esenciales para mantenerte fuerte y protegido contra enfermedades.',
    image: '/imagenes/blog-importancia-vacunas.png',
    content: `¡Hola amiguitos y papis! 🐾 Soy Capy, y hoy vamos a hablar de algo súper importante: ¡las vacunas!
    Algunos piensan que las vacunas son solo un pinchacito molesto, ¡pero no! Son como escudos mágicos o superpoderes que le damos a nuestro cuerpo.
    Imagina que tu cuerpo es un castillo increíble. Las vacunas son como entrenadores que enseñan a tus soldaditos (tus defensas) a reconocer y luchar contra los villanos (los gérmenes y virus) antes de que puedan causar problemas grandes.
    Así, si un villano de verdad intenta atacar tu castillo, ¡tus soldaditos ya saben qué hacer y lo vencen rapidísimo!
    Cada vacuna te protege de una enfermedad diferente, como el sarampión, la polio, la gripe y muchas más. Es muy importante seguir el calendario de vacunación que te indica tu pediatra en Crecer Pediatría. ¡Así estarás siempre listo para la aventura y para crecer sano y fuerte!
    Recuerda, vacunarse es un acto de amor, ¡contigo mismo y con todos los que te rodean! Porque si tú estás protegido, también ayudas a proteger a tus amigos y familia.
    ¡Nos vemos en Crecer para tu próxima dosis de superpoderes! 💪✨`,
  },
  {
    id: 2,
    title: 'Comiendo colores: ¡Una aventura nutritiva!',
    category: 'Alimentación Saludable',
    author: 'Capy',
    date: '20 de Mayo, 2025',
    summary: 'Descubre con Capy cómo una alimentación llena de colores puede ser deliciosa y súper saludable para crecer grande y fuerte.',
    image: '/imagenes/blog-comiendo-colores.png',
    content: `¡Hola exploradores de sabores! 🌈 Soy Capy, y hoy quiero invitarlos a una aventura deliciosa: ¡comer un arcoíris todos los días!
    No, no me refiero a morder el cielo (¡aunque sería divertido!), sino a llenar tu plato con frutas y verduras de muchos colores. Cada color nos da diferentes vitaminas y minerales que nuestro cuerpo necesita para jugar, aprender y crecer súper fuerte.
    🔴 **Rojo:** Como las fresas, manzanas y tomates. ¡Son geniales para tu corazón y tu memoria!
    🟠 **Naranja:** Como las zanahorias, naranjas y mangos. ¡Te dan súper vista y piel sana!
    🟡 **Amarillo:** Como los plátanos, piñas y pimientos amarillos. ¡Te llenan de energía para todo el día!
    🟢 **Verde:** Como el brócoli, las espinacas y las uvas verdes. ¡Hacen tus huesos y dientes fuertes!
    🟣 **Morado/Azul:** Como las uvas moradas, los arándanos y la berenjena. ¡Ayudan a tu cerebro a pensar mejor!
    Comer un plato colorido no solo es divertido, ¡sino que también es la mejor manera de asegurarte de que estás recibiendo todos los nutrientes que necesitas! Pídele a tus papis que te ayuden a incluir muchos colores en tus comidas.
    En Crecer Pediatría, la Dra. Diana Andia es experta en nutrición y puede darles muchos más consejos.
    ¡A comer colores y a crecer sanos y felices! 🍓🥕🍌🥦🍇`,
  },
  {
    id: 3,
    title: '¡A jugar se ha dicho! Desarrollo y diversión',
    category: 'Desarrollo Infantil',
    author: 'Capy',
    date: '15 de Mayo, 2025',
    summary: 'El juego es fundamental para el desarrollo de los niños. Capy te da ideas divertidas para aprender mientras juegas.',
    image: '/imagenes/blog-jugar-desarrollo.png',
    content: `¡Amiguitos, a jugar! 🎉 Soy Capy, y si hay algo que me encanta más que un buen pasto fresco, ¡es jugar!
    ¿Sabían que jugar no es solo diversión? ¡Es la forma más importante en la que los niños aprenden y crecen! Cuando juegas:
    🧠 **Tu cerebro se vuelve más inteligente:** Resuelves problemas, usas tu imaginación y aprendes cosas nuevas.
    💪 **Tu cuerpo se hace más fuerte:** Corres, saltas, trepas y mejoras tu coordinación.
    🤝 **Aprendes a hacer amigos:** Compartes, esperas tu turno y trabajas en equipo.
    😊 **Te sientes feliz y relajado:** El juego ayuda a liberar el estrés y te hace sonreír.
    No importa si juegas con bloques, a las escondidas, con muñecos, pintando o inventando historias. ¡Todo juego es valioso!
    Papis, recuerden que darles tiempo y espacio para jugar libremente es uno de los mejores regalos que pueden ofrecer a sus hijos. Y si tienen dudas sobre el desarrollo de sus peques a través del juego, ¡en Crecer Pediatría estamos para ayudarles!
    ¡Así que salgan, exploren y diviértanse jugando! 🧸⚽🎨`,
  },
  {
    id: 4,
    title: 'El sueño reparador: Clave para niños felices',
    category: 'Desarrollo Infantil',
    author: 'Dra. Diana Andia',
    date: '10 de Mayo, 2025',
    summary: 'Un buen descanso es crucial para el desarrollo físico y mental de los niños. Aprende a establecer rutinas de sueño saludables.',
    image: '/imagenes/blog-sueno-reparador.png',
    content: `Hola, soy la Dra. Diana Andia de Crecer Pediatría. Hoy quiero hablarles sobre algo fundamental para la salud y felicidad de sus hijos: ¡el sueño! 😴
    Dormir bien no es un lujo, es una necesidad básica, especialmente para los niños que están en pleno crecimiento y desarrollo. Durante el sueño:
    * **El cuerpo se repara y crece:** Se liberan hormonas de crecimiento.
    * **El cerebro procesa información:** Se consolida lo aprendido durante el día y se fortalecen las conexiones neuronales.
    * **El sistema inmunológico se fortalece:** Ayuda a combatir enfermedades.
    * **Se regula el humor y la energía:** Un niño descansado es un niño más feliz y activo.
    **¿Cuántas horas necesitan dormir?**
    * Recién nacidos: 14-17 horas
    * Bebés (4-11 meses): 12-15 horas
    * Niños pequeños (1-2 años): 11-14 horas
    * Preescolares (3-5 años): 10-13 horas
    * Niños en edad escolar (6-13 años): 9-11 horas
    * Adolescentes (14-17 años): 8-10 horas
    **Consejos para un buen descanso:**
    1.  **Establece una rutina:** Horarios consistentes para acostarse y levantarse, incluso los fines de semana.
    2.  **Crea un ambiente relajante:** Habitación oscura, tranquila y a una temperatura agradable.
    3.  **Evita pantallas antes de dormir:** La luz azul de tablets, teléfonos o TV puede interferir con el sueño.
    4.  **Actividad física durante el día:** Ayuda a cansar el cuerpo para un mejor descanso nocturno.
    5.  **Cena ligera:** Evita comidas pesadas o azucaradas cerca de la hora de dormir.
    Si tienes dudas sobre los hábitos de sueño de tu hijo, no dudes en consultarnos en Crecer Pediatría. ¡Un buen descanso es clave para un crecimiento saludable!`,
  },
];

const ABOUT_PAGE_VALUES = [
  { name: 'Calidez', desc: 'Brindamos un trato amable y cercano, creando un ambiente de confianza para niños y padres.', icon: <Smile /> },
  { name: 'Humanismo', desc: 'Ponemos a la persona en el centro de nuestra atención, respetando su individualidad y emociones.', icon: <HeartHandshake /> },
  { name: 'Profesionalismo', desc: 'Actuamos con ética, responsabilidad y conocimiento actualizado, siguiendo los más altos estándares médicos.', icon: <Stethoscope /> },
  { name: 'Compromiso', desc: 'Estamos dedicados a la salud y bienestar de nuestros pacientes, acompañándolos en cada etapa.', icon: <ShieldCheck /> },
  { name: 'Confianza', desc: 'Construimos relaciones sólidas basadas en la transparencia, honestidad y comunicación efectiva.', icon: <Users /> },
  { name: 'Innovación', desc: 'Buscamos constantemente mejorar nuestros servicios y aplicar los avances tecnológicos en beneficio de los pacientes.', icon: <Lightbulb /> },
];

const WHY_CHOOSE_US_PILLARS = [
  { title: 'Equipo Calificado', text: 'Pediatras con amplia experiencia y vocación.', icon: <Users className="w-10 h-10 text-[#0073E4]" /> },
  { title: 'Tecnología Moderna', text: 'Equipamiento de vanguardia para diagnósticos precisos.', icon: <Lightbulb className="w-10 h-10 text-[#0E92C8]" /> },
  { title: 'Atención Cálida y Humana', text: 'Nos enfocamos en el bienestar emocional de tus pequeños.', icon: <HeartHandshake className="w-10 h-10 text-[#0073E4]" /> },
  { title: 'Enfoque Profesional', text: 'Protocolos actualizados y atención basada en evidencia.', icon: <ShieldCheck className="w-10 h-10 text-[#0E92C8]" /> },
];

const PROCESS_STEPS = [
  {
    icon: <CalendarDays size={32} className="text-[#0073E4]" />,
    title: 'Agenda tu Cita',
    description: 'Contáctanos fácilmente por teléfono o WhatsApp para programar tu consulta en el horario que más te convenga.'
  },
  {
    icon: <Stethoscope size={32} className="text-[#0073E4]" />,
    title: 'Visita Personalizada',
    description: 'Recibe atención médica dedicada y un diagnóstico preciso en un ambiente cálido y amigable para los niños.'
  },
  {
    icon: <HeartHandshake size={32} className="text-[#0073E4]" />,
    title: 'Seguimiento Continuo',
    description: 'Acompañamos el desarrollo de tu hijo con controles periódicos y estamos disponibles para resolver tus dudas.'
  }
];


// --- ICONOS PERSONALIZADOS ---


// --- COMPONENTES REUTILIZABLES GLOBALES ---
const Navbar = ({ currentPage, navigateTo }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navLinksToDisplay = NAV_LINKS;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <a onClick={() => navigateTo('Inicio')} className="cursor-pointer flex-shrink-0 flex items-center">
              <img className="h-12 w-auto" src="/imagenes/logo-crecer-pediatria-navbar.png" alt="Crecer Pediatría Logo" onError={(e) => { e.target.src = 'https://placehold.co/200x80/0073E4/FFFFFF?text=Logo'; console.error("Error al cargar /imagenes/logo-crecer-pediatria-navbar.png.") }} />
            </a>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-1">
              {navLinksToDisplay.map((link) => (
                <a
                  key={link.name}
                  onClick={() => navigateTo(link.href)}
                  className={`cursor-pointer px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150
                    ${(currentPage === link.href || (link.name === 'Agendar Cita' && currentPage === 'Contacto'))
                      ? 'bg-[#0073E4] text-white'
                      : 'text-gray-700 hover:bg-slate-100 hover:text-[#0073E4]'
                    }
                    ${link.name === 'Agendar Cita' ? 'ml-2 bg-[#0E92C8] text-white hover:bg-[#0073E4] hover:text-white' : ''}`}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#0073E4]"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Abrir menú principal</span>
              {!isOpen ? <Menu className="block h-6 w-6" aria-hidden="true" /> : <X className="block h-6 w-6" aria-hidden="true" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinksToDisplay.map((link) => (
              <a
                key={link.name}
                onClick={() => { navigateTo(link.href); setIsOpen(false); }}
                className={`cursor-pointer block px-3 py-2 rounded-md text-base font-medium transition-colors duration-150
                  ${(currentPage === link.href || (link.name === 'Agendar Cita' && currentPage === 'Contacto'))
                    ? 'bg-[#0073E4] text-white'
                    : 'text-gray-700 hover:bg-slate-100 hover:text-[#0073E4]'
                  }
                  ${link.name === 'Agendar Cita' ? 'bg-[#0E92C8] text-white hover:bg-[#0073E4]' : ''}`}
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

const Footer = ({ navigateTo }) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-slate-800 text-slate-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img className="h-10 mb-4" src="/imagenes/logo-crecer-pediatria-footer.png" alt="Crecer Pediatría" onError={(e) => { e.target.src = 'https://placehold.co/180x60/FFFFFF/0073E4?text=Logo'; console.error("Error al cargar /imagenes/logo-crecer-pediatria-footer.png.") }} />
            <p className="text-sm text-slate-400">Cuidando la salud de tus hijos en Cusco, paso a pasito.</p>
            <div className="flex space-x-4 mt-4">
              <a href="https://www.facebook.com/CrecerPediatriaCusco" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white"><span className="sr-only">Facebook</span><Facebook size={24} /></a>
              <a href="https://www.instagram.com/crecerpediatriacusco/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white"><span className="sr-only">Instagram</span><Instagram size={24} /></a>
              <a href="https://www.tiktok.com/@crecerpediatriacusco" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white"><span className="sr-only">TikTok</span><FaTiktok size={24} /></a>
              <a href="#" onClick={(e) => { e.preventDefault(); alert('Link de YouTube pendiente'); }} className="text-slate-400 hover:text-white"><span className="sr-only">YouTube</span><Youtube size={24} /></a>
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase text-slate-400">Navegación</h3>
            <ul className="mt-4 space-y-2">
              {NAV_LINKS.map(link => (
                <li key={link.name}><a onClick={() => navigateTo(link.href)} className="text-base text-slate-400 hover:text-white cursor-pointer">{link.name}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase text-slate-400">Contacto</h3>
            <ul className="mt-4 space-y-2 text-slate-400">
              <li className="flex items-start"><MapPin size={20} className="mr-2 mt-1 flex-shrink-0 text-sky-400" />Av. Los Incas 1403, Cusco (Altura del Hospital Regional, frente al paradero de Urcos).</li>
              <li className="flex items-center"><Phone size={20} className="mr-2 flex-shrink-0 text-sky-400" /><a href={`tel:${NEW_PHONE_NUMBER}`} className="hover:text-white">{NEW_PHONE_NUMBER_DISPLAY}</a></li>
              <li className="flex items-center"><Mail size={20} className="mr-2 flex-shrink-0 text-sky-400" /><a href="mailto:info@crecerpediatriacusco.com" className="hover:text-white">info@crecerpediatriacusco.com</a></li>
              <li className="flex items-center"><Clock3 size={20} className="mr-2 flex-shrink-0 text-sky-400" />Horarios: Lun - Sáb: 8am - 8pm</li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase text-slate-400">Legal</h3>
            <ul className="mt-4 space-y-2">
              <li><a onClick={() => alert('Página de Políticas de Privacidad pendiente.')} className="text-base text-slate-400 hover:text-white cursor-pointer">Políticas de Privacidad</a></li>
              <li><a onClick={() => alert('Página de Términos y Condiciones pendiente.')} className="text-base text-slate-400 hover:text-white cursor-pointer">Términos y Condiciones</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-slate-700 pt-8 text-sm text-center text-slate-500">
          <p>© {currentYear} Crecer Pediatría. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};


const BottomNavigation = ({ currentPage, navigateTo }) => {
  const [activeIcon, setActiveIcon] = useState('inicio');

  useEffect(() => {
    if (currentPage === 'Inicio') setActiveIcon('inicio');
    else if (currentPage === 'Contacto' && activeIcon !== 'mapa') setActiveIcon('agendar');
    else if (currentPage === 'El Rincón de Capy') setActiveIcon('capy');
  }, [currentPage]);

  const handleNavClick = (section, iconName) => {
    setActiveIcon(iconName);
    navigateTo(section);
  };

  return (
    <div className="fixed bottom-6 w-full z-50 md:hidden flex justify-center pb-safe pointer-events-none px-4">
      <div className="bg-white rounded-[35px] shadow-[0px_8px_30px_rgba(0,0,0,0.15)] flex justify-between items-center py-2 px-4 w-full max-w-sm pointer-events-auto relative border border-slate-100">
        <button
          onClick={() => handleNavClick('Inicio', 'inicio')}
          className={`flex flex-col items-center justify-center p-3 transition-colors duration-300 ${activeIcon === 'inicio' ? 'text-[#0073E4]' : 'text-slate-400 hover:text-slate-600'}`}
        >
          <Home size={24} strokeWidth={activeIcon === 'inicio' ? 2.5 : 2} />
        </button>

        <button
          onClick={() => handleNavClick('Contacto', 'agendar')}
          className={`flex flex-col items-center justify-center p-3 transition-colors duration-300 ${activeIcon === 'agendar' ? 'text-[#0073E4]' : 'text-slate-400 hover:text-slate-600'}`}
        >
          <CalendarDays size={24} strokeWidth={activeIcon === 'agendar' ? 2.5 : 2} />
        </button>

        {/* Central Call Button */}
        <a
          href={`tel:${NEW_PHONE_NUMBER}`}
          className="relative -top-4 flex items-center justify-center bg-gradient-to-tr from-sky-400 to-[#0073E4] rounded-full w-14 h-14 shadow-xl shadow-blue-500/40 text-white hover:scale-105 active:scale-95 transition-transform duration-300 border-4 border-white z-10"
        >
          <Phone size={24} strokeWidth={2.5} className="fill-white" />
        </a>

        <button
          onClick={() => {
            setActiveIcon('mapa');
            navigateTo('Contacto');
            setTimeout(() => { const el = document.getElementById('ubicacion-mapa'); if (el) el.scrollIntoView({ behavior: 'smooth' }) }, 100);
          }}
          className={`flex flex-col items-center justify-center p-3 transition-colors duration-300 ${activeIcon === 'mapa' ? 'text-[#0073E4]' : 'text-slate-400 hover:text-slate-600'}`}
        >
          <MapPin size={24} strokeWidth={activeIcon === 'mapa' ? 2.5 : 2} />
        </button>

        <button
          onClick={() => handleNavClick('El Rincón de Capy', 'capy')}
          className={`flex flex-col items-center justify-center p-3 transition-colors duration-300 ${activeIcon === 'capy' ? 'text-[#0073E4]' : 'text-slate-400 hover:text-slate-600'}`}
        >
          <Smile size={24} strokeWidth={activeIcon === 'capy' ? 2.5 : 2} />
        </button>
      </div>
    </div>
  );
};

// --- COMPONENTES DE SECCIONES DE PÁGINA ---
const HeroSection = ({ navigateTo }) => (
  <div className="bg-gradient-to-br from-[#0073E4] to-[#1e40af] text-white relative overflow-hidden py-16 md:py-32">
    <div className="absolute inset-0 -z-10">
      <div className="absolute -top-40 -left-40 w-96 h-96 bg-sky-400/20 rounded-full filter blur-3xl opacity-50 animate-pulse-slow" style={{ animationDuration: '20s', '--opacity-start': 0.2, '--opacity-end': 0.4 }}></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-blue-500/20 rounded-full filter blur-3xl opacity-50 animate-pulse-slow animation-delay-3000" style={{ animationDuration: '25s', '--opacity-start': 0.15, '--opacity-end': 0.35 }}></div>
    </div>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
      <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold mb-4 text-shadow-soft leading-tight max-w-3xl mx-auto">
        Cuidando la Salud de tus Hijos en Cusco
      </h1>
      <p className="text-base sm:text-xl text-sky-50 mb-8 max-w-2xl mx-auto font-medium">
        Atención médica integral para niños y adolescentes con un equipo altamente calificado, tecnología moderna y un enfoque cálido, humano y profesional.
      </p>
      <div className="flex flex-col gap-3 justify-center max-w-xs mx-auto">
        <button
          onClick={() => navigateTo('Contacto')}
          className="w-full bg-white text-[#0073E4] font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-sky-50 transition duration-300 text-base"
        >
          Agendar Cita
        </button>
        <button
          onClick={() => navigateTo('Servicios')}
          className="w-full bg-transparent border-[1.5px] border-white text-white font-semibold py-3 px-8 rounded-lg hover:bg-white/10 transition duration-300 text-base"
        >
          Nuestros Servicios
        </button>
      </div>
    </div>
  </div>
);

const BookAppointmentBar = ({ navigateTo }) => {
  const [service, setService] = useState('');
  const [date, setDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  });
  const [pediatrician, setPediatrician] = useState('');

  const handleSearchAvailability = () => {
    let whatsappMessage = `¡Hola Crecer Pediatría! Quisiera consultar disponibilidad.\n\n`;
    if (service) whatsappMessage += `Servicio: ${service}\n`;
    if (date) whatsappMessage += `Fecha: ${date}\n`;
    if (pediatrician && pediatrician !== 'any' && pediatrician !== 'Cualquier Pediatra Disponible') {
      whatsappMessage += `Pediatra: ${pediatrician}\n`;
    } else if (pediatrician === 'any' || pediatrician === 'Cualquier Pediatra Disponible') {
      whatsappMessage += `Pediatra: Cualquiera disponible\n`;
    }
    whatsappMessage += `\nEspero su pronta respuesta.`;
    const whatsappUrl = `https://wa.me/${NEW_PHONE_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="py-10 bg-slate-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-6 sm:p-8 rounded-xl shadow-xl">
          <h2 className="text-2xl font-bold text-slate-800 mb-6 text-center">Agenda tu Cita Fácilmente</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 items-end">
            <div className="w-full">
              <label htmlFor="service-select-bar" className="block text-sm font-medium text-slate-700 mb-1">Servicio</label>
              <div className="relative">
                <BriefcaseMedical className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
                <select id="service-select-bar" value={service} onChange={(e) => setService(e.target.value)} className="w-full pl-10 pr-8 py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm appearance-none">
                  <option value="">Elige un servicio</option>
                  {SERVICES_DATA_FOR_SELECT.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
              </div>
            </div>
            <div className="w-full">
              <label htmlFor="date-select-bar" className="block text-sm font-medium text-slate-700 mb-1">Fecha</label>
              <div className="relative">
                <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
                <input type="date" id="date-select-bar" value={date} onChange={(e) => setDate(e.target.value)} className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm" />
              </div>
            </div>
            <div className="w-full">
              <label htmlFor="pediatrician-select-bar" className="block text-sm font-medium text-slate-700 mb-1">Pediatra</label>
              <div className="relative">
                <User2 className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
                <select id="pediatrician-select-bar" value={pediatrician} onChange={(e) => setPediatrician(e.target.value)} className="w-full pl-10 pr-8 py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm appearance-none">
                  <option value="">Elige un pediatra</option>
                  {DOCTORS_DATA_FOR_SELECT.map(doc => <option key={doc.id} value={doc.name}>{doc.name}</option>)}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
              </div>
            </div>
            <button onClick={handleSearchAvailability} className="w-full bg-[#0073E4] text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-[#0E92C8] transition duration-300 text-sm flex items-center justify-center md:self-end md:h-[42px]">
              <MessageSquare size={18} className="mr-2" /> Consultar por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const MeetOurTeamSection = ({ navigateTo, showViewAllButton = false }) => {
  return (
    <section className="py-16 bg-sky-50 relative overflow-hidden border-t border-b border-sky-200">
      <div className="absolute -top-1/4 -left-1/4 w-1/2 h-full bg-sky-200/30 rounded-full filter blur-3xl opacity-50 animate-pulse-slow" style={{ animationDuration: '25s' }}></div>
      <div className="absolute -bottom-1/4 -right-1/4 w-1/2 h-full bg-blue-200/20 rounded-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-2000" style={{ animationDuration: '30s' }}></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <header className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Nuestro Equipo</h2>
          <p className="text-md md:text-lg text-slate-600 mt-2 max-w-2xl mx-auto">
            Profesionales dedicados y apasionados por el cuidado integral de la salud infantil.
          </p>
        </header>

        <div className="flex justify-center">
          <img
            src="/imagenes/equipo-crecer-pediatria-quienes-somos.png"
            alt="Equipo de Crecer Pediatría"
            className="rounded-xl shadow-xl mx-auto max-w-2xl w-full object-cover h-auto max-h-[500px]"
            onError={(e) => { e.target.src = 'https://placehold.co/800x500/cccccc/FFFFFF?text=Nuestro+Equipo'; console.error("Error al cargar /imagenes/equipo-crecer-pediatria-quienes-somos.png.") }}
          />
        </div>
        {showViewAllButton && (
          <div className="mt-12">
            <button
              onClick={() => navigateTo('Nuestro Equipo')}
              className="bg-[#0073E4] text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-[#0E92C8] transition duration-300"
            >
              Conoce a Todos los Especialistas
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

const WhyChooseUsSection = ({ navigateTo, scrollToElement }) => (
  <section className="py-16 bg-slate-50 relative overflow-hidden">
    <div className="absolute -top-1/4 -right-1/4 w-2/3 h-2/3 bg-sky-200/20 rounded-full filter blur-3xl opacity-60 z-0"></div>
    <div className="absolute -bottom-1/4 -left-1/4 w-2/3 h-2/3 bg-blue-200/15 rounded-full filter blur-3xl opacity-50 z-0"></div>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">¿Por Qué Confiar en Crecer Pediatría?</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {WHY_CHOOSE_US_PILLARS.map(pillar => (
          <div key={pillar.title} className="bg-white p-6 rounded-xl shadow-lg text-center transition-all duration-300 hover:shadow-2xl hover:scale-105">
            <div className="flex justify-center mb-4">{pillar.icon}</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">{pillar.title}</h3>
            <p className="text-gray-600 text-sm">{pillar.text}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center bg-white p-8 rounded-xl shadow-xl max-w-2xl mx-auto border-2 border-sky-300">
        <Sparkles className="w-12 h-12 text-[#0073E4] mx-auto mb-4" />
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">¡Conoce a Capy!</h3>
        <p className="text-gray-600 mb-4">Nuestra mascota Capy hace que cada visita sea una aventura divertida y educativa.</p>
        <button onClick={() => { navigateTo('Quiénes Somos'); setTimeout(() => scrollToElement('capy-section'), 100); }} className="bg-[#0073E4] text-white font-semibold py-2.5 px-6 rounded-lg hover:bg-[#0E92C8] transition duration-300">
          Descubre a Capy
        </button>
      </div>
    </div>
  </section>
);

const TestimonialsSection = () => (
  <section className="py-16 bg-gradient-to-r from-sky-500 to-blue-600 text-white relative overflow-hidden">
    <div className="absolute top-0 left-0 w-full h-full opacity-20 z-0">
      <div className="absolute -top-1/4 left-1/4 w-1/2 h-1/2 bg-white/10 rounded-full filter blur-2xl animate-pulse-slow animation-delay-1000"></div>
      <div className="absolute -bottom-1/4 right-1/4 w-1/2 h-1/2 bg-white/5 rounded-full filter blur-2xl animate-pulse-slow animation-delay-4000"></div>
    </div>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <h2 className="text-3xl font-bold text-center mb-12">Lo que Nuestros Pacientes Dicen</h2>
      <div className="grid md:grid-cols-3 gap-8">
        {TESTIMONIALS.map(testimonial => (
          <div key={testimonial.name} className="bg-white/10 backdrop-blur-md p-6 rounded-xl shadow-lg hover:bg-white/20 transition-all duration-300 flex flex-col">
            <Star className="w-6 h-6 text-yellow-400 mb-3" />
            <p className="text-md italic mb-4 flex-grow">"{testimonial.quote}"</p>
            <div>
              <p className="font-semibold">{testimonial.name}</p>
              <p className="text-sm opacity-80">{testimonial.city}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const BlogSection = ({ navigateTo }) => {
  const recentPosts = BLOG_POSTS.slice(0, 3);

  if (recentPosts.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-white relative overflow-hidden">
      <div className="absolute top-0 -right-1/4 w-1/2 h-full bg-sky-100/20 rounded-l-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-1000" style={{ animationDuration: '28s' }}></div>
      <div className="absolute bottom-0 -left-1/4 w-1/2 h-full bg-blue-100/15 rounded-r-full filter blur-3xl opacity-30 animate-pulse-slow animation-delay-3000" style={{ animationDuration: '32s' }}></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <header className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Últimos Consejos de Capy</h2>
          <p className="text-md md:text-lg text-slate-600 mt-2 max-w-xl mx-auto">
            Mantente al día con nuestros últimos artículos y consejos para el cuidado de tus pequeños.
          </p>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recentPosts.map(post => (
            <div
              key={post.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col transition-all duration-300 hover:shadow-2xl hover:scale-[1.03] group"
            >
              <div className="w-full h-48 sm:h-56 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => { e.target.src = 'https://placehold.co/600x400/cccccc/FFFFFF?text=Blog'; console.error(`Error al cargar ${post.image}.`) }}
                />
              </div>
              <div className="p-5 flex flex-col flex-grow">
                <div>
                  <span className="text-xs font-semibold text-[#0073E4] uppercase mb-1 inline-flex items-center">
                    <Tag size={12} className="mr-1.5" />{post.category}
                  </span>
                  <h3
                    className="text-lg font-bold text-slate-800 mt-1 mb-1.5 group-hover:text-[#0073E4] transition-colors duration-300 cursor-pointer line-clamp-2"
                    onClick={() => { navigateTo('Consejos de Capy'); setTimeout(() => { const postEl = document.getElementById(`post-id-${post.id}`); if (postEl) postEl.scrollIntoView({ behavior: 'smooth' }); }, 100); }}
                    title={post.title}
                  >
                    {post.title}
                  </h3>
                  <p className="text-xs text-slate-500 mb-2">
                    <UserCircle size={12} className="inline mr-1 opacity-70" /> {post.author}
                    <span className="mx-1.5">|</span>
                    <CalendarRange size={12} className="inline mr-1 opacity-70" /> {post.date}
                  </p>
                  <p className="text-slate-600 text-sm mb-3 leading-relaxed line-clamp-3">{post.summary}</p>
                </div>
                <button
                  onClick={() => { navigateTo('Consejos de Capy'); setTimeout(() => { const postEl = document.getElementById(`post-id-${post.id}`); if (postEl) postEl.scrollIntoView({ behavior: 'smooth' }); }, 100); }}
                  className="self-start text-[#0073E4] font-semibold hover:text-[#0E92C8] group-hover:text-[#0E92C8] transition-colors duration-300 inline-flex items-center text-sm mt-auto"
                >
                  Leer más <ArrowRight size={16} className="ml-1.5 transform transition-transform duration-200 group-hover:translate-x-1" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {BLOG_POSTS.length > recentPosts.length && (
          <div className="text-center mt-12">
            <button
              onClick={() => navigateTo('Consejos de Capy')}
              className="bg-slate-200 text-slate-700 font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-slate-300 hover:text-slate-800 transition duration-300 transform hover:scale-105 text-md"
            >
              Ver Todos los Consejos
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

const LocationContactSection = () => (
  <section className="py-16 bg-slate-50 relative overflow-hidden">
    <div className="absolute top-0 right-0 w-1/2 h-full bg-sky-100/30 rounded-l-full filter blur-3xl opacity-50 translate-x-1/2 z-0"></div>
    <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-blue-100/20 rounded-r-full filter blur-3xl opacity-40 -translate-x-1/3 z-0"></div>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Encuéntranos Fácilmente</h2>
      <div className="grid md:grid-cols-2 gap-8 items-center">
        <div className="bg-white p-3 sm:p-4 rounded-xl shadow-xl">
          <div className="relative w-full overflow-hidden rounded-lg border border-slate-200 shadow-sm" style={{ paddingTop: '56.25%' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3879.200040389098!2d-71.953092985198!3d-13.522627990499999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd60ae2838779%3A0x8a61f0b625003966!2sHospital%20Regional%20del%20Cusco!5e0!3m2!1sen!2spe!4v1673000000000"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de Ubicación de Crecer Pediatría"
              className="absolute top-0 left-0 w-full h-full"
            ></iframe>
          </div>
        </div>
        <div className="text-center md:text-left bg-white p-6 sm:p-8 rounded-xl shadow-xl">
          <p className="text-lg text-gray-700 mb-1"><strong className="text-[#0073E4]">Dirección:</strong></p>
          <p className="text-gray-600 mb-3">Av. Los Incas 1403, Cusco (Altura del Hospital Regional, frente al paradero de Urcos).</p>
          <p className="text-lg text-gray-700 mb-1"><strong className="text-[#0073E4]">Teléfono:</strong></p>
          <p className="text-gray-600 mb-4">{NEW_PHONE_NUMBER_DISPLAY}</p>
          <div className="mt-6 flex flex-col sm:flex-row justify-center md:justify-start space-y-3 sm:space-y-0 sm:space-x-3">
            <a href={`tel:${NEW_PHONE_NUMBER}`} className="bg-[#0073E4] text-white font-semibold py-2.5 px-5 rounded-lg shadow-md hover:bg-[#0E92C8] transition duration-300 flex items-center justify-center text-sm">
              <Phone size={18} className="mr-2" /> Llamar Ahora
            </a>
            <a href={`https://wa.me/${NEW_PHONE_NUMBER}?text=Hola%2C%20quisiera%20consultar%20sobre%20sus%20servicios%20en%20Crecer%20Pediatría.`} target="_blank" rel="noopener noreferrer" className="bg-slate-600 text-white font-semibold py-2.5 px-5 rounded-lg shadow-md hover:bg-slate-700 transition duration-300 flex items-center justify-center text-sm">
              <MessageSquare size={18} className="mr-2" /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const DoctorCard = ({ doctor, onProfileView }) => {
  if (!doctor) {
    return null;
  }
  return (
    <div
      key={doctor.name}
      className="bg-white rounded-xl shadow-lg flex flex-col overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] border border-slate-200 h-full"
    >
      <div className="w-full h-64 sm:h-72 md:h-80 overflow-hidden">
        <img
          src={doctor.imgSrc}
          alt={doctor.name}
          className="w-full h-full object-cover object-center"
          style={doctor.imgStyle || {}}
          onError={(e) => {
            e.target.src = 'https://placehold.co/400x350/cccccc/FFFFFF?text=Doctor';
            console.error(`Error al cargar ${doctor.imgSrc}.`)
          }}
        />
      </div>
      <div className="p-5 text-center flex-grow flex flex-col">
        <h3 className="text-xl font-bold text-slate-800">{doctor.name}</h3>
        <p className="text-[#0073E4] font-medium text-sm mb-2">{doctor.specialty}</p>
        <div className="space-x-1 mb-4">
          {doctor.areas.slice(0, 2).map(area => (
            <span key={area} className="inline-block bg-sky-100 text-sky-700 text-xs font-medium px-2 py-0.5 rounded-full">{area}</span>
          ))}
        </div>
        {onProfileView && (
          <div className="mt-auto">
            <button
              onClick={() => onProfileView(doctor)}
              className="w-full bg-slate-100 text-slate-700 hover:bg-slate-200 text-xs font-semibold py-2.5 px-4 rounded-md transition-colors duration-200"
            >
              Ver Perfil Completo
            </button>
          </div>
        )}
      </div>
      <div className="h-1.5 bg-gradient-to-r from-[#0073E4] to-[#0E92C8]"></div>
    </div>
  );
};

const FAQSection = ({ navigateTo }) => {
  const faqData = [
    { question: "¿Qué edades atienden en Crecer Pediatría?", answer: "Atendemos a niños desde el nacimiento (recién nacidos) hasta la adolescencia (generalmente hasta los 18 años). Ofrecemos controles de niño sano, vacunación, atención de enfermedades comunes y consejería para adolescentes." },
    { question: "¿Necesito agendar una cita o puedo ir directamente?", answer: "Recomendamos agendar una cita para asegurar que podamos atenderte sin demoras y dedicarte el tiempo necesario. Para emergencias, por favor contáctanos directamente por teléfono." },
    { question: "¿Qué debo llevar a la primera consulta de mi bebé?", answer: "Para la primera consulta, es útil traer el carnet de control de embarazo (si lo tienes), cualquier informe del hospital sobre el nacimiento, el carnet de vacunación del bebé (si ya tiene alguno) y tu DNI." },
    { question: "¿Cómo puedo saber qué vacunas necesita mi hijo?", answer: "Nosotros seguimos el Esquema Nacional de Vacunación y las recomendaciones internacionales. En cada control de niño sano, revisaremos el carnet de tu hijo y te indicaremos las vacunas correspondientes a su edad." },
    { question: "¿Qué hago si mi hijo se enferma fuera del horario de atención?", answer: "Para emergencias graves, debes acudir al servicio de urgencias del hospital más cercano. Para consultas urgentes fuera de horario, puedes contactarnos al número de WhatsApp y te orientaremos de la mejor manera posible." }
  ];

  const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
      <div className="border-b border-slate-200 py-4">
        <button
          className="w-full flex justify-between items-center text-left text-slate-700 hover:text-[#0073E4] focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="font-semibold text-md">{question}</span>
          {isOpen ? <ChevronUp className="w-5 h-5 text-[#0073E4]" /> : <ChevronDown className="w-5 h-5 text-slate-500" />}
        </button>
        {isOpen && (
          <div className="mt-3 text-slate-600 text-sm leading-relaxed pr-8">
            <p>{answer}</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <section className="py-16 bg-slate-100 relative overflow-hidden">
      <div className="absolute -top-1/3 -left-1/4 w-3/4 h-3/4 bg-sky-200/10 rounded-full filter blur-3xl opacity-40 animate-pulse-slow" style={{ animationDuration: '30s' }}></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <header className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Preguntas Frecuentes</h2>
          <p className="text-md md:text-lg text-slate-600 mt-2 max-w-xl mx-auto">
            Encuentra respuestas a las dudas más comunes sobre nuestros servicios y atención.
          </p>
        </header>
        <div className="max-w-3xl mx-auto bg-white p-6 sm:p-8 rounded-xl shadow-xl">
          {faqData.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
};

// --- NEW SECTIONS FOR HOMEPAGE ---
const ProcessSection = () => (
  <section className="py-16 bg-white">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <span className="text-sm font-semibold text-[#0073E4] uppercase tracking-wider">Nuestro Proceso</span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">Simple y Efectivo para tu Tranquilidad</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-8 text-center">
        {PROCESS_STEPS.map((step, index) => (
          <div key={index} className="p-6 bg-slate-50 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="flex justify-center items-center mb-4 w-16 h-16 bg-sky-100 rounded-full mx-auto">
              {step.icon}
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">{step.title}</h3>
            <p className="text-gray-600 text-sm">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const FeaturedDoctorsSection = ({ navigateTo }) => {
  const featuredDoctors = DOCTORS.slice(0, 5); // Show all 5 doctors

  return (
    <section className="py-16 bg-sky-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-[#0073E4] uppercase tracking-wider">Nuestros Especialistas</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">Conoce a Nuestros Pediatras Expertos</h2>
          <p className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto">
            Un equipo de profesionales dedicados al cuidado de la salud infantil con calidez y experiencia.
          </p>
        </div>
        {/* Responsive grid for 5 doctors: 1 col on sm, 2 on md, 3 on lg, 5 on xl if desired, or wrap */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 md:gap-8">
          {featuredDoctors.map(doctor => (
            <DoctorCard key={doctor.name} doctor={doctor} />
          ))}
        </div>
        {DOCTORS.length > 5 && ( // Show button only if there are more doctors than shown
          <div className="text-center mt-12">
            <button
              onClick={() => navigateTo('Nuestro Equipo')}
              className="bg-[#0073E4] text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-[#0E92C8] transition duration-300"
            >
              Ver Todo el Equipo
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

const CallToActionSection = ({ navigateTo }) => (
  <section className="py-16 bg-gradient-to-r from-[#0073E4] to-[#0E92C8] text-white">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Sparkles className="w-12 h-12 mx-auto mb-4 opacity-80" />
      <h2 className="text-3xl md:text-4xl font-bold mb-4">¿Listos para Cuidar de tus Pequeños?</h2>
      <p className="text-lg text-sky-100 mb-8 max-w-xl mx-auto">
        Agenda una cita hoy mismo y da el primer paso hacia una infancia saludable y feliz para tus hijos. Estamos aquí para ayudarte.
      </p>
      <button
        onClick={() => navigateTo('Contacto')}
        className="bg-white text-[#0073E4] font-semibold py-3 px-10 rounded-lg shadow-lg hover:bg-sky-100 transition duration-300 transform hover:scale-105 text-lg"
      >
        Agendar Cita Ahora
      </button>
    </div>
  </section>
);


// --- PÁGINAS ---
const HomePage = ({ navigateTo, scrollToElement }) => (
  <>
    <HeroSection navigateTo={navigateTo} />
    <BookAppointmentBar navigateTo={navigateTo} />
    <FeaturedDoctorsSection navigateTo={navigateTo} /> {/* Moved and updated */}
    <ProcessSection />
    {/* FeaturedServicesSection removed from here */}
    <TestimonialsSection />
    <BlogSection navigateTo={navigateTo} />
    <WhyChooseUsSection navigateTo={navigateTo} scrollToElement={scrollToElement} /> {/* Moved after BlogSection */}
    <FAQSection navigateTo={navigateTo} />
    <CallToActionSection navigateTo={navigateTo} />
    <LocationContactSection />
  </>
);

const AboutPage = ({ navigateTo, scrollToElement }) => {
  return (
    <div className="bg-slate-50 py-12 relative overflow-hidden">
      <div className="absolute -top-1/4 -left-1/4 w-3/4 h-3/4 bg-sky-200/15 rounded-full filter blur-3xl opacity-50 animate-pulse-slow animation-delay-2000" style={{ animationDuration: '30s' }}></div>
      <div className="absolute -bottom-1/4 -right-1/4 w-3/4 h-3/4 bg-blue-200/10 rounded-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-5000" style={{ animationDuration: '35s' }}></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <header className="text-center mb-16 pt-8">
          <div className="mb-4 text-sm text-gray-500">
            <a onClick={() => navigateTo('Inicio')} className="hover:text-[#0073E4] cursor-pointer">Inicio</a>
            <ChevronRight size={16} className="inline mx-1 opacity-50" />
            <span>Quiénes Somos</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0073E4] mb-4">Sobre Crecer Pediatría</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Conoce nuestra filosofía, el equipo que te atenderá y por qué somos la mejor opción para el cuidado de tus hijos en Cusco.
          </p>
        </header>

        <MeetOurTeamSection navigateTo={navigateTo} showViewAllButton={false} />

        <section id="capy-section" className="my-16 py-12 bg-gradient-to-br from-[#0E92C8] to-[#0073E4] rounded-xl shadow-xl text-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold mb-6">¡Capy, Tu Amigo en Crecer Pediatría!</h2>
            <img
              src="/imagenes/capy-feliz-quienes-somos.png"
              alt="Capy, la mascota de Crecer Pediatría"
              className="w-48 h-48 md:w-64 md:h-64 rounded-full shadow-2xl mx-auto mb-8 border-4 border-white"
              onError={(e) => { e.target.src = 'https://placehold.co/250x250/A0522D/FFFFFF?text=Capy'; console.error("Error al cargar /imagenes/capy-feliz-quienes-somos.png.") }}
            />
            <p className="text-xl mb-6 max-w-3xl mx-auto leading-relaxed">
              Capy es nuestra mascota oficial, una tierna capibara que acompaña a los niños en su visita. Capy explica de forma divertida cómo cuidar su salud, ¡y ayuda a que cada consulta sea una experiencia positiva y sin temores! Él estará presente en nuestra clínica y en nuestros materiales educativos.
            </p>
            <div className="bg-white/20 backdrop-blur-sm p-6 rounded-lg inline-block">
              <p className="text-2xl font-semibold italic">“¡Hola, amiguitos! 🐾 Soy Capy, y estoy aquí para ayudarte a estar sanito y feliz. ¡Nos vemos en Crecer!”</p>
            </div>
          </div>
        </section>

        <section className="mb-16 bg-white p-8 rounded-xl shadow-xl">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-[#0073E4] mb-4">Nuestra Misión</h2>
              <Target size={32} className="text-[#0073E4] mb-3" />
              <p className="text-gray-700 text-lg">
                Brindar atención pediátrica integral de la más alta calidad, centrada en el paciente y su familia, promoviendo la salud y el bienestar de los niños y adolescentes de Cusco a través de un enfoque humano, ético y profesional.
              </p>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-[#0E92C8] mb-4">Nuestra Visión</h2>
              <Eye size={32} className="text-[#0E92C8] mb-3" />
              <p className="text-gray-700 text-lg">
                Ser el centro pediátrico líder y de referencia en la región de Cusco, reconocido por nuestra excelencia médica, innovación tecnológica y el trato cálido y cercano que nos caracteriza.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-16 bg-white p-8 rounded-xl shadow-xl">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Nuestra Historia</h2>
          <Building size={32} className="text-slate-500 mx-auto mb-4" />
          <p className="text-gray-600 text-lg max-w-3xl mx-auto text-center">
            Crecer Pediatría nació del sueño de un grupo de pediatras cusqueños apasionados por la salud infantil. Motivados por la necesidad de un centro que combine excelencia médica con un trato verdaderamente humano, unimos fuerzas para crear un espacio donde cada niño se sienta seguro y cada familia, escuchada. Desde nuestra fundación en 2023, hemos crecido junto a nuestros pequeños pacientes, celebrando cada hito y superando juntos cada desafío.
          </p>
        </section>

        <section className="mb-16 bg-white p-8 rounded-xl shadow-xl">
          <h2 className="text-3xl font-bold text-gray-800 mb-10 text-center">Nuestros Valores Fundamentales</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {ABOUT_PAGE_VALUES.map(value => (
              <div key={value.name} className="bg-slate-50 p-6 rounded-xl shadow-lg border-t-4 border-[#0073E4] hover:shadow-xl transition-shadow duration-300">
                <div className="flex justify-center mb-3">
                  {React.cloneElement(value.icon, { size: 32, className: `text-[#0073E4]` })}
                </div>
                <h3 className="text-xl font-semibold text-slate-700 text-center mb-2">{value.name}</h3>
                <p className="text-slate-600 text-sm text-center">{value.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

const ServicesPage = ({ navigateTo }) => {
  return (
    <div className="bg-slate-50 py-12 relative overflow-hidden">
      <div className="absolute -top-1/4 -right-1/4 w-3/4 h-3/4 bg-sky-200/15 rounded-full filter blur-3xl opacity-50 animate-pulse-slow animation-delay-1000" style={{ animationDuration: '26s' }}></div>
      <div className="absolute -bottom-1/4 -left-1/4 w-3/4 h-3/4 bg-blue-200/10 rounded-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-4000" style={{ animationDuration: '29s' }}></div>
      <Star className="absolute top-[5%] right-[10%] w-5 h-5 text-sky-300 opacity-30 animate-pulse-slow animation-delay-500" />
      <Circle fill="currentColor" className="absolute bottom-[5%] left-[10%] w-4 h-4 text-blue-300 opacity-20 animate-pulse-slow animation-delay-2500" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <header className="text-center mb-16 pt-8">
          <div className="mb-4 text-sm text-gray-500">
            <a onClick={() => navigateTo('Inicio')} className="hover:text-[#0073E4] cursor-pointer">Inicio</a>
            <ChevronRight size={16} className="inline mx-1 opacity-50" />
            <span>Servicios</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0073E4] mb-4">Atención Médica Integral para Cada Etapa</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            En Crecer Pediatría, ofrecemos una amplia gama de servicios diseñados para cubrir todas las necesidades de salud de tus hijos, desde el nacimiento hasta la adolescencia.
          </p>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {SERVICES.map(service => (
            <div key={service.title} className="bg-white p-6 rounded-xl shadow-lg flex flex-col transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="flex justify-center mb-5">
                {React.cloneElement(service.icon, { className: "w-16 h-16 text-[#0073E4]" })}
              </div>
              <h3 className="text-xl font-semibold text-slate-800 mb-2 text-center">{service.title}</h3>
              <p className="text-slate-600 text-sm mb-4 flex-grow text-center">{service.description}</p>

              <img
                src={service.serviceImage}
                alt={`Imagen de ${service.title}`}
                className="rounded-lg my-4 h-40 w-full object-cover self-center shadow-sm"
                onError={(e) => { e.target.src = 'https://placehold.co/600x400/cccccc/FFFFFF?text=Servicio'; console.error(`Error al cargar ${service.serviceImage}.`) }}
              />

              {service.capyHelps && (
                <div className="mt-auto bg-sky-50 p-3.5 rounded-lg border-l-4 border-sky-300 flex items-center space-x-3">
                  <img
                    src={service.capyImage}
                    alt="Capy consejo"
                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                    onError={(e) => { e.target.src = 'https://placehold.co/80x80/A0522D/FFFFFF?text=C'; console.error(`Error al cargar ${service.capyImage}.`) }}
                  />
                  <p className="text-xs text-sky-700 italic"><strong className="font-semibold text-sky-800">Capy dice:</strong> {service.capyHelps}</p>
                </div>
              )}

            </div>
          ))}
        </div>

        <section className="py-12 md:py-16 bg-white rounded-xl shadow-xl my-16 relative overflow-hidden">
          <div className="absolute -top-1/2 -left-1/3 w-full h-full bg-sky-100/40 rounded-full filter blur-3xl opacity-70 animate-pulse-slow" style={{ animationDuration: '30s' }}></div>
          <div className="absolute -bottom-1/2 -right-1/3 w-full h-full bg-blue-100/30 rounded-full filter blur-3xl opacity-60 animate-pulse-slow animation-delay-2000" style={{ animationDuration: '35s' }}></div>

          <div className="container mx-auto px-6 lg:px-8 text-center relative z-10">
            <Sparkles className="w-12 h-12 text-[#0073E4] mx-auto mb-4" />
            <h2 className="text-3xl font-bold text-slate-800 mb-4">Tu Tranquilidad es Nuestra Prioridad</h2>
            <p className="text-slate-600 text-lg max-w-xl mx-auto mb-8">
              Contáctanos hoy mismo para agendar una cita o para resolver cualquier duda. Estamos aquí para acompañarte en cada paso del crecimiento de tus hijos.
            </p>
            <button
              onClick={() => navigateTo('Contacto')}
              className="bg-[#0073E4] text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-[#0E92C8] transition duration-300 text-lg transform hover:scale-105"
            >
              Agenda tu Cita Ahora
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

const TeamPage = ({ navigateTo }) => {
  return (
    <div className="bg-slate-50 py-12 relative overflow-hidden">
      <div className="absolute -top-1/3 -left-1/3 w-full h-full bg-sky-200/10 rounded-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-3000" style={{ animationDuration: '28s' }}></div>
      <div className="absolute -bottom-1/3 -right-1/3 w-full h-full bg-blue-200/05 rounded-full filter blur-3xl opacity-30 animate-pulse-slow animation-delay-6000" style={{ animationDuration: '31s' }}></div>
      <Star className="absolute top-[8%] left-[15%] w-4 h-4 text-sky-300 opacity-25 animate-pulse-slow animation-delay-800" />
      <Circle fill="currentColor" className="absolute bottom-[12%] right-[18%] w-3 h-3 text-blue-300 opacity-15 animate-pulse-slow animation-delay-3200" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <header className="text-center mb-16 pt-8">
          <div className="mb-4 text-sm text-gray-500">
            <a onClick={() => navigateTo('Inicio')} className="hover:text-[#0073E4] cursor-pointer">Inicio</a>
            <ChevronRight size={16} className="inline mx-1 opacity-50" />
            <span>Nuestro Equipo</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0073E4] mb-4">Conoce a Nuestros Especialistas</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Nuestro equipo de pediatras altamente calificados y con gran vocación está dedicado al cuidado integral de tus hijos. Cada uno de nuestros profesionales combina experiencia, conocimiento actualizado y un trato humano excepcional.
          </p>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 md:gap-10">
          {DOCTORS.map(doctor => (
            <DoctorCard
              key={doctor.name}
              doctor={doctor}
            />
          ))}
        </div>

        <section className="mt-16 text-center bg-gradient-to-r from-[#0073E4] to-[#0E92C8] text-white p-10 rounded-xl shadow-lg">
          <h2 className="text-3xl font-bold mb-4">Un Equipo Unido por la Salud de tus Hijos</h2>
          <p className="text-lg max-w-2xl mx-auto">
            En Crecer Pediatría, trabajamos juntos para ofrecerte la mejor atención. ¡Estamos aquí para acompañarte en la maravillosa aventura de ver crecer a tus hijos sanos y felices!
          </p>
        </section>
      </div>
    </div>
  );
};

const ContactPage = ({ navigateTo }) => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', pediatrician: '', appointmentDate: '', message: '' });
  const handleChange = (e) => { const { name, value } = e.target; setFormData(prev => ({ ...prev, [name]: value })); };
  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phone, email, pediatrician, appointmentDate, message } = formData;
    let whatsappMessage = `¡Hola Crecer Pediatría! Quisiera ponerme en contacto.\n\nNombre: ${name}\nTeléfono: ${phone}\n`;
    if (email) whatsappMessage += `Email: ${email}\n`;
    if (pediatrician && pediatrician !== 'any' && pediatrician !== 'Cualquier Pediatra Disponible' && pediatrician !== '') whatsappMessage += `Pediatra de Preferencia: ${pediatrician}\n`;
    if (appointmentDate) whatsappMessage += `Fecha de Cita Sugerida: ${appointmentDate}\n`;
    whatsappMessage += `Mensaje: ${message}`;
    const whatsappUrl = `https://wa.me/${NEW_PHONE_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');
    setFormData({ name: '', phone: '', email: '', pediatrician: '', appointmentDate: '', message: '' });
  };

  return (
    <div className="bg-slate-50 py-12 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full -z-10">
        <div className="absolute -top-1/4 -left-1/4 w-3/4 h-3/4 bg-sky-200/20 rounded-full filter blur-3xl opacity-50 animate-pulse-slow" style={{ animationDuration: '25s' }}></div>
        <div className="absolute -bottom-1/4 -right-1/4 w-3/4 h-3/4 bg-blue-200/15 rounded-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-4000" style={{ animationDuration: '30s' }}></div>
      </div>
      <Star className="absolute top-[10%] right-[5%] w-6 h-6 text-sky-300 opacity-40 animate-pulse-slow animation-delay-1000" />
      <Circle fill="currentColor" className="absolute bottom-[10%] left-[5%] w-4 h-4 text-blue-300 opacity-30 animate-pulse-slow animation-delay-3000" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pb-8">
        <header className="text-center mb-10 pt-8">
          <div className="mb-4 text-sm text-gray-500">
            <a onClick={() => navigateTo('Inicio')} className="hover:text-[#0073E4] cursor-pointer">Inicio</a>
            <ChevronRight size={16} className="inline mx-1 opacity-50" />
            <span>Agendar Cita / Contacto</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-[#0073E4] mb-4">Agenda tu Cita o Contáctanos</h1>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            Estamos aquí para responder tus preguntas y ayudarte a programar tu próxima visita.
          </p>
        </header>

        <div className="flex flex-col-reverse lg:grid lg:grid-cols-5 gap-6 lg:gap-10 mb-10 lg:mb-16">
          <div className="lg:col-span-2 bg-white p-5 sm:p-8 rounded-xl shadow-lg border border-slate-100">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4 sm:mb-6">Información de Contacto</h2>
            <ul className="space-y-4 sm:space-y-5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start"> <MapPin size={18} className="text-[#0073E4] mr-3 mt-0.5 flex-shrink-0" /> <div> <strong className="text-slate-800 block">Dirección</strong> Av. Los Incas 1403, Cusco, Perú. <br /> <span className="text-xs text-slate-500">(Altura del Hospital Regional, frente al paradero de Urcos).</span> </div> </li>
              <li className="flex items-start"> <Phone size={18} className="text-[#0073E4] mr-3 mt-0.5 flex-shrink-0" /> <div> <strong className="text-slate-800 block">Teléfono Central</strong> <a href={`tel:${NEW_PHONE_NUMBER}`} className="text-[#0E92C8] hover:underline font-medium">{NEW_PHONE_NUMBER_DISPLAY}</a> <div className="mt-2 flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2"> <a href={`tel:${NEW_PHONE_NUMBER}`} className="bg-[#0073E4] text-white text-xs font-semibold py-1.5 px-3 rounded-md hover:bg-[#0E92C8] transition duration-300 flex items-center justify-center"> <Phone size={14} className="mr-1.5" /> Llamar </a> <a href={`https://wa.me/${NEW_PHONE_NUMBER}?text=Hola%2C%20quisiera%20hacer%20una%20consulta.`} target="_blank" rel="noopener noreferrer" className="bg-slate-600 text-white text-xs font-semibold py-1.5 px-3 rounded-md hover:bg-slate-700 transition duration-300 flex items-center justify-center"> <MessageSquare size={14} className="mr-1.5" /> WhatsApp </a> </div> </div> </li>
              <li className="flex items-start"> <Mail size={18} className="text-[#0073E4] mr-3 mt-0.5 flex-shrink-0" /> <div> <strong className="text-slate-800 block">Email</strong> <a href="mailto:citas@crecerpediatriacusco.com" className="text-[#0E92C8] hover:underline break-all">citas@crecerpediatriacusco.com</a> </div> </li>
              <li className="flex items-start"> <Clock3 size={18} className="text-[#0073E4] mr-3 mt-0.5 flex-shrink-0" /> <div> <strong className="text-slate-800 block">Horarios de Atención</strong> <ul className="list-none ml-0 text-xs sm:text-sm text-slate-600 space-y-1 mt-1"> <li>Lunes a Sábado: 8:00 AM - 8:00 PM</li> <li>Domingos: Cerrado</li> </ul> </div> </li>
            </ul>
            <hr className="my-5 lg:my-6 border-slate-200" />
            <h3 className="text-base sm:text-lg font-semibold text-slate-800 mb-3">Síguenos</h3>
            <div className="flex space-x-3 sm:space-x-4"> <a href="https://www.facebook.com/CrecerPediatriaCusco" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-[#0073E4] transition-colors"><Facebook size={24} /></a> <a href="https://www.instagram.com/crecerpediatriacusco/" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-[#0073E4] transition-colors"><Instagram size={24} /></a> <a href="https://www.tiktok.com/@crecerpediatriacusco" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-black transition-colors"><FaTiktok size={24} /></a> <a href="#" onClick={(e) => { e.preventDefault(); alert('Link de YouTube pendiente'); }} className="text-slate-500 hover:text-red-600 transition-colors"><Youtube size={24} /></a> </div>
          </div>

          <div className="lg:col-span-3 bg-white p-5 sm:p-8 rounded-xl shadow-lg border border-slate-100">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4 sm:mb-6">Envíanos un Mensaje Directo</h2>
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                <div> <label htmlFor="name-contact" className="block text-xs sm:text-sm font-medium text-slate-600 mb-1">Nombre Completo <span className="text-red-500">*</span></label> <input type="text" name="name" id="name-contact" value={formData.name} onChange={handleChange} required className="mt-1 block w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm" /> </div>
                <div> <label htmlFor="phone-contact" className="block text-xs sm:text-sm font-medium text-slate-600 mb-1">Teléfono <span className="text-red-500">*</span></label> <input type="tel" name="phone" id="phone-contact" value={formData.phone} onChange={handleChange} required className="mt-1 block w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm" /> </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                <div> <label htmlFor="email-contact" className="block text-xs sm:text-sm font-medium text-slate-600 mb-1">Email <span className="text-slate-400 font-normal">(Opcional)</span></label> <input type="email" name="email" id="email-contact" value={formData.email} onChange={handleChange} className="mt-1 block w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm" /> </div>
                <div> <label htmlFor="appointmentDate-contact" className="block text-xs sm:text-sm font-medium text-slate-600 mb-1">Fecha de Cita <span className="text-slate-400 font-normal">(Opcional)</span></label> <input type="date" name="appointmentDate" id="appointmentDate-contact" value={formData.appointmentDate} onChange={handleChange} className="mt-1 block w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm" /> </div>
              </div>
              <div> <label htmlFor="pediatrician-contact" className="block text-xs sm:text-sm font-medium text-slate-600 mb-1">Seleccione su Pediatra <span className="text-slate-400 font-normal">(Opcional)</span></label> <select name="pediatrician" id="pediatrician-contact" value={formData.pediatrician} onChange={handleChange} className="mt-1 block w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-slate-300 bg-white rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm" > <option value="">Cualquiera...</option> {DOCTORS_DATA_FOR_SELECT.map(doc => <option key={doc.id} value={doc.name}>{doc.name}</option>)} </select> </div>
              <div> <label htmlFor="message-contact" className="block text-xs sm:text-sm font-medium text-slate-600 mb-1">Tu Mensaje <span className="text-red-500">*</span></label> <textarea name="message" id="message-contact" value={formData.message} onChange={handleChange} rows="3" required className="mt-1 block w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-slate-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0073E4] focus:border-[#0073E4] text-sm"></textarea> </div>

              <div className="flex flex-col sm:flex-row items-center justify-between pt-2 gap-4">
                <p className="text-[11px] sm:text-xs text-slate-500 text-center sm:text-left">Aceptas nuestra política de privacidad al enviar este mensaje.</p>
                <button type="submit" className="w-full sm:w-auto inline-flex justify-center py-2.5 px-6 border border-transparent rounded-lg shadow-sm text-sm sm:text-base font-semibold text-white bg-[#0073E4] hover:bg-[#0E92C8] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0073E4] transition-colors">
                  Enviar Mensaje
                </button>
              </div>
            </form>
          </div>
        </div>

        <div id="ubicacion-mapa" className="mt-16 bg-white p-6 sm:p-8 rounded-xl shadow-xl">
          <h2 className="text-2xl font-semibold text-slate-800 mb-4 text-center">Nuestra Ubicación</h2>
          <div className="relative w-full h-[350px] sm:h-[450px] lg:h-[500px] overflow-hidden rounded-lg border border-slate-200 shadow-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3879.200040389098!2d-71.953092985198!3d-13.522627990499999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd60ae2838779%3A0x8a61f0b625003966!2sHospital%20Regional%20del%20Cusco!5e0!3m2!1sen!2spe!4v1673000000000"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de Ubicación de Crecer Pediatría"
              className="absolute top-0 left-0 w-full h-full"
            ></iframe>
          </div>
          <div className="text-center mt-4">
            <a
              href="https://www.google.com/maps/place/Hospital+Regional+del+Cusco/@-13.522628,-71.9552816,17z/data=!3m1!4b1!4m6!3m5!1s0x916dd60ae2838779:0x8a61f0b625003966!8m2!3d-13.522628!4d-71.9530929!16s%2Fg%2F1tdy802g?entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#0073E4] text-white font-semibold py-2.5 px-5 rounded-lg hover:bg-[#0E92C8] transition duration-300 text-sm"
            >
              Cómo Llegar en Google Maps
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const BlogPage = ({ navigateTo }) => {
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const postsPerPage = 4;
  const featuredPost = BLOG_POSTS.length > 0 ? BLOG_POSTS[0] : null;
  const allPostsForPagination = BLOG_POSTS.slice(0);

  const indexOfLastGridPost = currentPageNum * postsPerPage;
  const indexOfFirstGridPost = indexOfLastGridPost - postsPerPage;
  const currentGridPosts = allPostsForPagination.slice(indexOfFirstGridPost, indexOfLastGridPost);
  const totalPages = Math.ceil(allPostsForPagination.length / postsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPageNum(pageNumber);
      const blogListTop = document.getElementById('blog-list-section');
      if (blogListTop) {
        blogListTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const showPostContent = (post) => {
    const snippet = post.content.substring(0, 200) + (post.content.length > 200 ? "..." : "");
    alert(`Leyendo: ${post.title}\n\n${snippet}\n\n(Funcionalidad de lectura completa pendiente)`);
  };

  return (
    <div className="bg-slate-50 py-12 relative overflow-hidden">
      <div className="absolute -top-1/4 -right-1/4 w-3/4 h-3/4 bg-sky-200/15 rounded-full filter blur-3xl opacity-50 animate-pulse-slow animation-delay-1500"></div>
      <div className="absolute -bottom-1/4 -left-1/4 w-3/4 h-3/4 bg-blue-200/10 rounded-full filter blur-3xl opacity-40 animate-pulse-slow animation-delay-4500"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <header id="blog-header" className="text-center mb-12 pt-8">
          <div className="mb-4 text-sm text-gray-500"> <a onClick={() => navigateTo('Inicio')} className="hover:text-[#0073E4] cursor-pointer">Inicio</a> <ChevronRight size={16} className="inline mx-1 opacity-50" /> <span>Consejos de Capy</span> </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0073E4] mb-4">El Rincón de Capy</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto"> ¡Hola, amiguitos y papis! 🐾 Aquí en mi rincón encontrarán muchos consejos divertidos y útiles para cuidarnos, aprender sobre nuestro cuerpo y crecer superfuertes. </p>
        </header>

        {featuredPost && currentPageNum === 1 && (
          <section className="mb-12 md:mb-16" id={`post-id-${featuredPost.id}`}>
            <div className="bg-white rounded-xl shadow-xl overflow-hidden lg:flex transition-all duration-300 hover:shadow-2xl group">
              <div className="lg:w-1/2"> <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-64 lg:h-96 object-cover transform transition-transform duration-500 group-hover:scale-105" onError={(e) => { e.target.src = 'https://placehold.co/600x400/cccccc/FFFFFF?text=Blog+Imagen'; console.error(`Error al cargar ${featuredPost.image}.`) }} /> </div>
              <div className="lg:w-1/2 p-6 md:p-8 flex flex-col justify-center"> <span className="text-xs font-semibold text-[#0073E4] uppercase mb-1">{featuredPost.category}</span> <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-2 group-hover:text-[#0073E4] transition-colors duration-300 cursor-pointer" onClick={() => showPostContent(featuredPost)}>{featuredPost.title}</h2> <p className="text-sm text-slate-500 mb-3"> <UserCircle size={14} className="inline mr-1 opacity-70" /> {featuredPost.author} <span className="mx-2">|</span> <CalendarRange size={14} className="inline mr-1 opacity-70" /> {featuredPost.date} </p> <p className="text-slate-600 text-sm mb-4 leading-relaxed line-clamp-4">{featuredPost.summary}</p> <button onClick={() => showPostContent(featuredPost)} className="self-start text-[#0073E4] font-semibold hover:text-[#0E92C8] group-hover:text-[#0E92C8] transition-colors duration-300 inline-flex items-center"> Leer Artículo Completo <ArrowRight size={16} className="ml-1.5 transform transition-transform duration-200 group-hover:translate-x-1" /> </button> </div>
            </div>
          </section>
        )}

        {currentGridPosts.length > 0 && (
          <section id="blog-list-section" className="mb-16">
            <h2 className="text-2xl font-bold text-slate-800 mb-8 text-center md:text-left">
              {currentPageNum === 1 && featuredPost && currentGridPosts.filter(post => post.id !== featuredPost.id).length > 0 ? "Más Consejos" : "Todos los Consejos"}
            </h2>
            <div className="grid grid-cols-1 gap-6 md:gap-8">
              {currentGridPosts.map(post => {
                if (currentPageNum === 1 && featuredPost && post.id === featuredPost.id) return null;
                return (
                  <div key={post.id} id={`post-id-${post.id}`} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col sm:flex-row transition-all duration-300 hover:shadow-2xl hover:scale-[1.01] group">
                    <div className="sm:w-1/3 md:w-1/4 flex-shrink-0 h-48 sm:h-auto overflow-hidden"> <img src={post.image} alt={post.title} className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105" onError={(e) => { e.target.src = 'https://placehold.co/300x200/cccccc/FFFFFF?text=Blog+Imagen'; console.error(`Error al cargar ${post.image}.`) }} /> </div>
                    <div className="p-5 flex flex-col flex-grow justify-between"> <div> <span className="text-xs font-semibold text-[#0073E4] uppercase mb-1 inline-flex items-center"><Tag size={12} className="mr-1.5" />{post.category}</span> <h3 className="text-lg font-bold text-slate-800 mt-1 mb-1.5 group-hover:text-[#0073E4] transition-colors duration-300 cursor-pointer" onClick={() => showPostContent(post)}>{post.title}</h3> <p className="text-xs text-slate-500 mb-2"> <UserCircle size={12} className="inline mr-1 opacity-70" /> {post.author} <span className="mx-1.5">|</span> <CalendarRange size={12} className="inline mr-1 opacity-70" /> {post.date} </p> <p className="text-slate-600 text-xs mb-3 leading-relaxed line-clamp-3">{post.summary}</p> </div> <button onClick={() => showPostContent(post)} className="self-start text-[#0073E4] font-semibold hover:text-[#0E92C8] group-hover:text-[#0E92C8] transition-colors duration-300 inline-flex items-center text-xs mt-2"> Leer más <ArrowRight size={14} className="ml-1 transform transition-transform duration-200 group-hover:translate-x-0.5" /> </button> </div>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {totalPages > 1 && (
          <div className="flex justify-center items-center space-x-1 sm:space-x-2 mt-12 mb-8">
            <button onClick={() => paginate(currentPageNum - 1)} disabled={currentPageNum === 1} className="px-3 py-2 text-xs sm:text-sm font-medium text-slate-600 bg-white rounded-md shadow-sm hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed border border-slate-300"> Anterior </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (<button key={number} onClick={() => paginate(number)} className={`px-3 py-2 text-xs sm:text-sm font-medium rounded-md shadow-sm border ${currentPageNum === number ? 'bg-[#0073E4] text-white border-[#0073E4]' : 'bg-white text-slate-600 hover:bg-slate-50 border-slate-300'}`}> {number} </button>))}
            <button onClick={() => paginate(currentPageNum + 1)} disabled={currentPageNum === totalPages} className="px-3 py-2 text-xs sm:text-sm font-medium text-slate-600 bg-white rounded-md shadow-sm hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed border border-slate-300"> Siguiente </button>
          </div>
        )}
        {(allPostsForPagination.length === 0) && (<p className="text-center text-gray-600 text-lg col-span-full mt-8">No hay artículos por ahora. ¡Vuelve pronto!</p>)}
      </div>
    </div>
  );
};

const NotFoundPage = ({ navigateTo }) => {
  return (
    <div className="bg-slate-100 flex flex-col items-center justify-center min-h-[calc(100vh-10rem)] px-4 text-center">
      <div className="absolute inset-0 -z-10 overflow-hidden"> <div className="absolute -top-1/3 -left-1/4 w-3/4 h-3/4 bg-sky-200/10 rounded-full filter blur-3xl opacity-30 animate-pulse-slow" style={{ animationDuration: '22s' }}></div> <div className="absolute -bottom-1/3 -right-1/4 w-3/4 h-3/4 bg-blue-300/05 rounded-full filter blur-3xl opacity-20 animate-pulse-slow animation-delay-3000" style={{ animationDuration: '28s' }}></div> </div>
      <div className="bg-white p-8 sm:p-12 rounded-xl shadow-2xl max-w-md w-full relative z-10"> <AlertTriangle className="w-16 h-16 text-amber-500 mx-auto mb-6" /> <h1 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-3">¡Oh no! Página No Encontrada</h1> <p className="text-slate-600 mb-8 text-lg"> Parece que la página que estás buscando no existe o ha sido movida. </p> <button onClick={() => navigateTo('Inicio')} className="bg-[#0073E4] text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-[#0E92C8] transition duration-300 text-md inline-flex items-center"> <Home size={20} className="mr-2" /> Volver a la Página de Inicio </button> </div>
    </div>
  );
};

// --- App Principal ---
function App() {
  const [currentPage, setCurrentPage] = useState('Inicio');
  const navigateTo = (page) => { setCurrentPage(page); window.scrollTo(0, 0); };
  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) { setTimeout(() => { element.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 100); }
    else { console.warn(`Elemento con id "${elementId}" no encontrado.`); }
  };

  useEffect(() => {
    const styleId = 'global-animations-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        @keyframes pulse-slow { 0%, 100% { opacity: var(--opacity-start, 0.2); transform: scale(var(--scale-start, 1)) rotate(var(--rotate-start, -2deg)); } 50% { opacity: var(--opacity-end, 0.4); transform: scale(var(--scale-end, 1.03)) rotate(var(--rotate-end, 2deg)); } }
        .animate-pulse-slow { animation: pulse-slow 15s infinite ease-in-out; }
        .animation-delay-1000 { animation-delay: -1s; } .animation-delay-2000 { animation-delay: -2s; } .animation-delay-3000 { animation-delay: -3s; } .animation-delay-4000 { animation-delay: -4s; } .animation-delay-5000 { animation-delay: -5s; } .animation-delay-6000 { animation-delay: -6s; }
        body { font-family: 'Inter', sans-serif; } .text-shadow-soft { text-shadow: 0px 1px 3px rgba(0, 50, 100, 0.2); }
        .hero-image-container img { max-width: 100%; height: auto; }
        /* Image Protection Styles */
        img { -webkit-user-drag: none; user-select: none; -webkit-touch-callout: none; }
        `;
      document.head.appendChild(style);
    }
    const fontLinkId = 'inter-font-link';
    if (!document.getElementById(fontLinkId)) {
      const link = document.createElement('link');
      link.id = fontLinkId;
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }


    // Image Protection Event Listeners
    const handleImageInteraction = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleImageInteraction);
    document.addEventListener('dragstart', handleImageInteraction);

    return () => {
      document.removeEventListener('contextmenu', handleImageInteraction);
      document.removeEventListener('dragstart', handleImageInteraction);
    };
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'Inicio': return <HomePage navigateTo={navigateTo} scrollToElement={scrollToElement} />;
      case 'Quiénes Somos': return <AboutPage navigateTo={navigateTo} scrollToElement={scrollToElement} />;
      case 'Servicios': return <ServicesPage navigateTo={navigateTo} />;
      case 'Nuestro Equipo': return <TeamPage navigateTo={navigateTo} />;
      case 'Contacto': return <ContactPage navigateTo={navigateTo} />;
      case 'Consejos de Capy': return <BlogPage navigateTo={navigateTo} />;
      default: return <NotFoundPage navigateTo={navigateTo} />;
    }
  };

  // Si estamos en "El Rincón de Capy", mostramos solo ese componente
  if (currentPage === 'El Rincón de Capy') {
    return <CapyCorner onNavigateHome={() => setCurrentPage('Inicio')} />;
  }

  // Estructura normal del sitio
  return (
    <div className="flex flex-col min-h-screen bg-slate-100 text-gray-800 pb-20 md:pb-0">
      <Navbar currentPage={currentPage} navigateTo={navigateTo} />
      <main className="flex-grow">
        {renderPage()}
      </main>
      <Footer navigateTo={navigateTo} />
      <BottomNavigation currentPage={currentPage} navigateTo={navigateTo} />
    </div>
  );
}

export default App;
